import React from 'react';
import { Link } from 'react-router-dom';

import Avatar from './Avatar';
import { getNameFromToken } from '../../actions';


class UserProfile extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      username: '',
    }
  }

  UNSAFE_componentWillMount () {
    const username = getNameFromToken();
    username ? this.setState({ username }) : this.pingForUsername();
  }

  pingForUsername () {
    let interval = null;
    interval = setInterval(() => {
      const username = getNameFromToken();
      if (username){
        clearInterval(interval);
        this.setState({username});
      }
    }, 300);
  }

  render () {
    const { username } = this.state;
    return (
      <div className="profile">
        <Avatar name={username} />
        <div className="popover">
          <span>{username}</span>
          <Link to='/logout'>Logout</Link>
        </div>
      </div>
    )
  }
}

export default UserProfile;
